import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SideMenuService {
  private menuToggler = new BehaviorSubject<boolean | undefined>(undefined);
  public $menuToggler = this.menuToggler.asObservable();

  public toggleMenu = (show = true) => {
    this.menuToggler.next(show);
  };
}
